import { forwardRef } from 'react'
import { Menu } from '@base-ui/react/menu'
import { ChevronRight } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { listItemChevron, listItemVariants } from '../../../lib/list-styles'

export interface MenuSubmenuTriggerProps extends Menu.SubmenuTrigger.Props {
  className?: string
  showIcon?: boolean
}

/** A row that opens a submenu. Stays highlighted while its submenu is open. */
const MenuSubmenuTrigger = forwardRef<HTMLDivElement, MenuSubmenuTriggerProps>(function MenuSubmenuTrigger(
  { className, children, showIcon = true, ...props },
  ref,
) {
  return (
    <Menu.SubmenuTrigger ref={ref} data-slot="list-item" className={twMerge(listItemVariants(), className)} {...props}>
      {children}
      {showIcon && <ChevronRight data-slot="list-item-chevron" className={listItemChevron} />}
    </Menu.SubmenuTrigger>
  )
})

export { MenuSubmenuTrigger }
